import apiClient from './apiClient';

// 인터셉터가 원본 axios 에러를 감싸면서 남겨주는 필드.
export interface ApiRequestError extends Error {
    status?: number;
    requestUrl?: string;
}

// 요청 인터셉터 등록
export function setupRequestInterceptor() {
    apiClient.interceptors.request.use(
        config => {
            return config;
        },
        error => {
            // 요청 에러 처리
            console.error('요청 중 에러 발생:', error.message);
            return Promise.reject(error);
        },
    );
}

// 응답 인터셉터 등록
export function setupResponseInterceptor() {
    apiClient.interceptors.response.use(
        response => {
            // 응답 데이터 전처리
            return response;
        },
        error => {
            // 응답 에러 처리
            if (error.response) {
                if (error.response.status === 401) {
                    console.warn('인증 실패: 재로그인 필요');
                } else if (error.response.status === 500) {
                    console.error('서버 오류 발생');
                }
            } else {
                console.error('서버로부터 응답 없음');
            }
            // AIDEV-NOTE: 메시지와 타입(Error)은 그대로 두되 status/url 은 실어 보낸다.
            // 예전엔 error.response 를 통째로 버려서, 호출부가 401(토큰 문제)과 500(서버 문제)을
            // 구분할 수 없었다. trend-report 의 재시도 판정과 Sentry 신고가 이 값을 읽는다.
            const wrapped = new Error('요청 처리 중 오류가 발생했습니다.') as ApiRequestError;
            wrapped.status = error.response?.status;
            wrapped.requestUrl = error.config?.url;

            return Promise.reject(wrapped);
        },
    );
}
